var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.curLanguage == 'zh')?_c('Banner'):_vm._e(),(_vm.curLanguage != 'zh')?_c('BannerLanguage'):_vm._e(),_c('Download')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }